import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import TagWizardRouter from "./TagWizardRouter";
import ThankYouPage from "./ThankYouPage";
import ManagePets from "./ManagePets";
import BoxComplete from "./BoxComplete";
//import LostPetReportByShape from "./LostPetReportByShape";
//import LostPetReportByShapeGrid from "./LostPetReportByShapeGrid";
//import PetPhotoCompare from "./PetPhotoCompare";


// add the following routes to experiment with the shapes UX 
//<Route path="/lost-pet-report-by-shape" element={<LostPetReportByShape />} />
//<Route path="/lost-pet-report-by-shape-grid" element={<LostPetReportByShapeGrid />}/>
//<Route path="/pet-photo-compare" element={<PetPhotoCompare />} />

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/manage-pets" element={<ManagePets />} />
        <Route path="/box-complete" element={<BoxComplete />} />
        <Route path="/:tagId" element={<TagWizardRouter />} />
            <Route path="/" element={<TagWizardRouter />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
      </Routes>
    </Router>
  );
}

export default App;
